import React, { useState, useEffect, useCallback } from "react";

import { useNavigate } from "react-router-dom";
// Import upsertSencoReport, upsertJiSiReport, and upsertSiFcReport
import {
  getSchools,
  updateStudent,
  upsertSencoReport,
  upsertJiSiReport,
  upsertSiFcReport,
  getCountryId
} from "../services/APIClient";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";

import PaginationComponent from "./PaginationComponent";

import "./ClassStudents.css";

function ClassStudents(props) {
  let students = props.students;
  let classDetails = props.classDetails;
  let teachers = props.teachers;
  let qrCodeDetails = props.qrCodeDetails;
  let schoolid = props.schoolid;
  let teacherRoles = props.teacherRoles;
  let isSnapshot = props.isSnapshot || props.classDetails?.snapshot;
  // Assuming teacherid is passed as a prop or available somehow
  let teacherid = props.teacherid; // Placeholder: Adjust if teacherid comes from elsewhere

  console.log(teacherid, "teacherid from ClassStudents");

  let navigate = useNavigate();

  const [countryId, setCountryId] = useState(null);
  const [studentUpdates, setStudentUpdates] = useState({}); // State to track checkbox values
  const [selectAll, setSelectAll] = useState({
    esl: false,
    sen: false,
    asd: false,
    gdd: false,
    send: false,
  }); // State to track "Select All"

 useEffect(() => {
     if (schoolid) {
       getCountryId(schoolid)
         .then((response) => {
           if (response.countryId) {
             console.log(response)
             setCountryId(response.countryId);
           } else {
             console.warn("No country ID found for school:", response.message);
             // Optionally set a default or leave as null
             setCountryId(null);
           }
         })
         .catch((error) => {
           console.error("Failed to fetch country ID:", error);
           // Optionally set a default value on error
           setCountryId(null);
         });
     }
   }, [schoolid]);

  useEffect(() => {
    if (students) {
      const initialState = {};
      students.forEach((student) => {
        initialState[student.id] = {
          esl: student.esl,
          sen: student.sen,
          asd: student.asd || false,
          gdd: student.gdd || false,
          send: student.send || false,
        };
      });
      setStudentUpdates(initialState);
    }
  }, [students]);

  // Handle individual checkbox changes
  const handleCheckboxChange = (studentId, field, value) => {
    if (isSnapshot) return; // Prevent changes in snapshot mode
    
    const updatedStudent = {
      ...studentUpdates[studentId],
      [field]: value,
    };
    setStudentUpdates((prev) => ({
      ...prev,
      [studentId]: updatedStudent,
    }));

    // Update student in backend
    updateStudent(studentId, updatedStudent)
      .then((response) => {
        console.log("Student updated successfully", response);
        // If the field updated was 'esl', also update the reports' 'eal' field
        if (field === "esl" && teacherid) {
          const reportData = {
            studentid: studentId,
            teacherid: teacherid, // Use the available teacher ID
            eal: value, // Sync eal with the new esl value
          };

          // Update SENCO Report
          upsertSencoReport(reportData)
            .then((sencoResponse) => {
              console.log(
                "SENCO report updated successfully for EAL sync",
                sencoResponse
              );
            })
            .catch((sencoError) => {
              console.error(
                "Failed to update SENCO report for EAL sync",
                sencoError
              );
            });

          // Update JISI Report
          upsertJiSiReport(reportData)
            .then((jisiResponse) => {
              console.log(
                "JISI report updated successfully for EAL sync",
                jisiResponse
              );
            })
            .catch((jisiError) => {
              console.error(
                "Failed to update JISI report for EAL sync",
                jisiError
              );
            });

          // Update SiFc Report
          upsertSiFcReport(reportData)
            .then((sifcResponse) => {
              console.log(
                "SiFc report updated successfully for EAL sync",
                sifcResponse
              );
            })
            .catch((sifcError) => {
              console.error(
                "Failed to update SiFc report for EAL sync",
                sifcError
              );
            });
        } else if (field === "esl" && !teacherid) {
          console.warn("Cannot sync ESL to reports: teacherid is missing.");
        }
      })
      .catch((error) => {
        console.error("Failed to update student", error);
        // Revert local state change on failure?
        setStudentUpdates((prev) => ({
          ...prev,
          [studentId]: {
            ...prev[studentId],
            [field]: !value, // Revert the checkbox state
          },
        }));
      });
  };

  // Handle "Select All" checkbox change
  const handleSelectAllChange = (field, value) => {
    if (isSnapshot) return; // Prevent changes in snapshot mode
    
    setSelectAll((prev) => ({
      ...prev,
      [field]: value,
    }));

    const updatedStudentsLocalState = { ...studentUpdates };
    students.forEach((student) => {
      updatedStudentsLocalState[student.id][field] = value;
    });
    setStudentUpdates(updatedStudentsLocalState);

    // Update all students in backend
    students.forEach((student) => {
      const updatedStudentData = { [field]: value }; // Only send the changed field
      updateStudent(student.id, updatedStudentData)
        .then((response) => {
          console.log(
            `Student ${student.id} updated successfully for ${field}`,
            response
          );
          // If the field updated was 'esl', also update the reports' 'eal' field
          if (field === "esl" && teacherid) {
            const reportData = {
              studentid: student.id,
              teacherid: teacherid, // Use the available teacher ID
              eal: value, // Sync eal with the new esl value
            };

            // Update SENCO Report
            upsertSencoReport(reportData)
              .then((sencoResponse) => {
                console.log(
                  `SENCO report updated successfully for EAL sync for student ${student.id}`,
                  sencoResponse
                );
              })
              .catch((sencoError) => {
                console.error(
                  `Failed to update SENCO report for EAL sync for student ${student.id}`,
                  sencoError
                );
              });

            // Update JISI Report
            upsertJiSiReport(reportData)
              .then((jisiResponse) => {
                console.log(
                  `JISI report updated successfully for EAL sync for student ${student.id}`,
                  jisiResponse
                );
              })
              .catch((jisiError) => {
                console.error(
                  `Failed to update JISI report for EAL sync for student ${student.id}`,
                  jisiError
                );
              });

            // Update SiFc Report
            upsertSiFcReport(reportData)
              .then((sifcResponse) => {
                console.log(
                  `SiFc report updated successfully for EAL sync for student ${student.id}`,
                  sifcResponse
                );
              })
              .catch((sifcError) => {
                console.error(
                  `Failed to update SiFc report for EAL sync for student ${student.id}`,
                  sifcError
                );
              });
          } else if (field === "esl" && !teacherid) {
            console.warn(
              `Cannot sync ESL to reports for student ${student.id}: teacherid is missing.`
            );
          }
        })
        .catch((error) => {
          console.error(
            `Failed to update student ${student.id} for ${field}`,
            error
          );
          // Revert local state change for this specific student on failure?
          setStudentUpdates((prev) => ({
            ...prev,
            [student.id]: {
              ...prev[student.id],
              [field]: !value, // Revert the checkbox state
            },
          }));
          // Also revert the 'Select All' checkbox if any update fails
          setSelectAll((prevSelectAll) => ({
            ...prevSelectAll,
            [field]: !value,
          }));
        });
    });
  };

  let classStudentsArray = [];
  if (students) {
    classStudentsArray = [...students].sort((a, b) => {
      let fa = a.name.trim().toLowerCase(),
        fb = b.name.trim().toLowerCase();
      if (fa < fb) return -1;
      if (fa > fb) return 1;
      return 0;
    });
  }

  const toStudentDetails = useCallback(
    (student) => {
      if (isSnapshot) return; // Prevent navigation in snapshot mode
      
      navigate("/student/details", {
        state: {
          student: { student },
          classDetails: { classDetails },
          teachers: { teachers },
          qrCodeDetails: { qrCodeDetails },
          students: { students },
          schoolid: { schoolid },
          teacherRoles: { teacherRoles },
        },
      });
    },
    [
      navigate,
      classDetails,
      teachers,
      qrCodeDetails,
      students,
      schoolid,
      teacherRoles,
      isSnapshot,
    ]
  );

  let [paginationItems, setPaginationItems] = useState([]);
  let [itemsPerPage] = useState(8);
  const [currentPage, setCurrentPage] = useState(1);
  const startItemIndex = (currentPage - 1) * itemsPerPage;
  const endItemIndex = startItemIndex + itemsPerPage;
  const currentItems =
    classStudentsArray?.slice(startItemIndex, endItemIndex) || [];

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage);
  };

  const irelandId = "07d45b79-24b1-435f-b82a-93861b23a86e";
  const englandId = "74bb2897-dbbe-41e3-b547-caee866545cf";

  return (
    <Row>
      <Col>
        <div>
          <h3 className="class-overview-table-header">
            Class Students ({classStudentsArray.length})
          </h3>
          {classStudentsArray.length <= itemsPerPage ? (
            ""
          ) : (
            <Row>
              <PaginationComponent
                itemsPerPage={itemsPerPage}
                totalItems={classStudentsArray.length}
                handlePageClick={handlePageClick}
              />
            </Row>
          )}
          {classStudentsArray.length === 0 ? (
            <Row className="roles">
              <h5 className="page-description-header">
                There are currently no students in your class.
              </h5>
              {!isSnapshot && (
                <h5 className="page-description-header">
                  Select "Add Students" above to start adding your students.
                </h5>
              )}
            </Row>
          ) : (
            <Table className="custom-table-class-students">
              <thead className="table-header">
                <tr>
                  <th>Name</th>
                  <th>
                    <div>
                      EAL
                      {/* {!isSnapshot && (
                        <input
                          type="checkbox"
                          checked={selectAll.esl}
                          onChange={(e) =>
                            handleSelectAllChange("esl", e.target.checked)
                          }
                        />
                      )} */}
                    </div>
                  </th>
                  <th>
                    <div>
                      Speech &<br />
                      Language
                      {/* {!isSnapshot && (
                        <input
                          type="checkbox"
                          checked={selectAll.sen}
                          onChange={(e) =>
                            handleSelectAllChange("sen", e.target.checked)
                          }
                        />
                      )} */}
                    </div>
                  </th>
                  {countryId === irelandId && (
                    <>
                      <th>
                        <div>
                          ASD
                          {/* {!isSnapshot && (
                            <input
                              type="checkbox"
                              checked={selectAll.asd}
                              onChange={(e) =>
                                handleSelectAllChange("asd", e.target.checked)
                              }
                            />
                          )} */}
                        </div>
                      </th>
                      <th>
                        <div>
                          GDD
                          {/* {!isSnapshot && (
                            <input
                              type="checkbox"
                              checked={selectAll.gdd}
                              onChange={(e) =>
                                handleSelectAllChange("gdd", e.target.checked)
                              }
                            />
                          )} */}
                        </div>
                      </th>
                    </>
                  )}
                  {countryId === englandId && (
                    <>
                      <th>
                        <div>
                          ASD
                          {/* {!isSnapshot && (
                            <input
                              type="checkbox"
                              checked={selectAll.asd}
                              onChange={(e) =>
                                handleSelectAllChange("asd", e.target.checked)
                              }
                            />
                          )} */}
                        </div>
                      </th>
                      <th>
                        <div>
                          GDD
                          {/* {!isSnapshot && (
                            <input
                              type="checkbox"
                              checked={selectAll.gdd}
                              onChange={(e) =>
                                handleSelectAllChange("gdd", e.target.checked)
                              }
                            />
                          )} */}
                        </div>
                      </th>
                      <th>
                        <div>
                          {/* SEND
                          {!isSnapshot && (
                            <input
                              type="checkbox"
                              checked={selectAll.send}
                              onChange={(e) =>
                                handleSelectAllChange("send", e.target.checked)
                              }
                            />
                          )} */}
                        </div>
                      </th>
                    </>
                  )}
                  {/* {!isSnapshot && <th>Edit/Change Class</th>} */}
                </tr>
              </thead>

              <tbody>
                {currentItems?.map((student, index) => {
                  const studentCheckboxes = studentUpdates[student.id];
                  return (
                    <tr key={index} className="table-row" id={student.id}>
                      <td className="table-data cursor-on">{student.name}</td>
                      <td>
                        {/* {isSnapshot ? (
                          <span>{studentCheckboxes?.esl ? "✓" : ""}</span>
                        ) : ( */}
                          <input
                            type="checkbox"
                            checked={studentCheckboxes?.esl || false}
                            disabled
                            onChange={(e) =>
                              handleCheckboxChange(
                                student.id,
                                "esl",
                                e.target.checked
                              )
                            }
                          />
                        {/* )} */}
                      </td>
                      <td>
                        {/* {isSnapshot ? (
                          <span>{studentCheckboxes?.sen ? "✓" : ""}</span>
                        ) : ( */}
                          <input
                            type="checkbox"
                            checked={studentCheckboxes?.sen || false}
                            disabled
                            onChange={(e) =>
                              handleCheckboxChange(
                                student.id,
                                "sen",
                                e.target.checked
                              )
                            }
                          />
                        {/* )} */}
                      </td>
                      {countryId === irelandId && (
                        <>
                          <td>
                            {/* {isSnapshot ? (
                              <span>{studentCheckboxes?.asd ? "✓" : ""}</span>
                            ) : ( */}
                              <input
                                type="checkbox"
                                checked={studentCheckboxes?.asd || false}
                                disabled
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    student.id,
                                    "asd",
                                    e.target.checked
                                  )
                                }
                              />
                            {/* )} */}
                          </td>
                          <td>
                            {/* {isSnapshot ? (
                              <span>{studentCheckboxes?.gdd ? "✓" : ""}</span>
                            ) : ( */}
                              <input
                                type="checkbox"
                                checked={studentCheckboxes?.gdd || false}
                                disabled
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    student.id,
                                    "gdd",
                                    e.target.checked
                                  )
                                }
                              />
                            {/* )} */}
                          </td>
                        </>
                      )}
                      {countryId === englandId && (
                        <>
                          <td>
                            {/* {isSnapshot ? (
                              <span>{studentCheckboxes?.asd ? "✓" : ""}</span>
                            ) : ( */}
                              <input
                                type="checkbox"
                                checked={studentCheckboxes?.asd || false}
                                disabled
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    student.id,
                                    "asd",
                                    e.target.checked
                                  )
                                }
                              />
                            {/* )} */}
                          </td>
                          <td>
                            {/* {isSnapshot ? (
                              <span>{studentCheckboxes?.gdd ? "✓" : ""}</span>
                            ) : ( */}
                              <input
                                type="checkbox"
                                checked={studentCheckboxes?.gdd || false}
                                disabled
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    student.id,
                                    "gdd",
                                    e.target.checked
                                  )
                                }
                              />
                            {/* )} */}
                          </td>
                          <td>
                            {/* {isSnapshot ? (
                              <span>{studentCheckboxes?.send ? "✓" : ""}</span>
                            ) : ( */}
                              <input
                                type="checkbox"
                                checked={studentCheckboxes?.send || false}
                                disabled
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    student.id,
                                    "send",
                                    e.target.checked
                                  )
                                }
                              />
                            {/* )} */}
                          </td>
                        </>
                      )}
                      {/* {!isSnapshot && (
                        <td>
                          <img
                            src="/assets/imgs/edit-icon.svg"
                            className="edit-students-cog"
                            alt="Settings"
                            onClick={() => toStudentDetails(student)}
                          />
                        </td>
                      )} */}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </div>
      </Col>
    </Row>
  );
}

export default ClassStudents;